import { jsx as _jsx } from "react/jsx-runtime";
import hexagonGreenUrl from '../../../assets/gems/hexagon_green.svg?inline';
export function HexagonGreen({ ...props }) {
    return _jsx("img", { ...props, src: hexagonGreenUrl, alt: 'HexagonGreenImage' });
}
